module.exports = __webpack_public_path__ + "img/diversidade.46b5c3af.svg";